var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height",
      attrs: {
        height: "100%"
      }
    },
    [
      _c(
        "gg-card-header",
        [
          _vm._v(" Ticket Validation "),
          _vm.validated
            ? _c(
                "v-icon",
                {
                  staticClass: "mb-2 ml-1",
                  attrs: {
                    size: "20",
                    color: "primary"
                  }
                },
                [_vm._v("mdi-check-circle")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "gg-card-text",
        {
          staticClass: "pb-2"
        },
        [
          _c(
            "p",
            {
              staticClass: "body-1"
            },
            [
              _vm._v(
                " Validating your ticket authorizes GreenGeeks to take action on your request. Click “Validate” to continue. "
              )
            ]
          ),
          _c("gg-input-label", [_vm._v("Related Service")]),
          _c("v-autocomplete", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "gg-input",
            attrs: {
              dense: "",
              outlined: "",
              placeholder: "Select a Related Service",
              filter: _vm.customServiceFilter,
              items: _vm.ticketServices,
              "item-value": "id",
              "data-vv-name": "service",
              "data-vv-as": "Service",
              "error-messages": _vm.errors.collect("service")
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _vm._v(" " + _vm._s(item.name) + " "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.domain,
                            expression: "item.domain"
                          }
                        ],
                        staticClass: "ml-1"
                      },
                      [_vm._v(" - " + _vm._s(item.domain) + " ")]
                    )
                  ]
                }
              },
              {
                key: "item",
                fn: function fn(_ref2) {
                  var item = _ref2.item
                  return [
                    _vm._v(" " + _vm._s(item.name) + " "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.domain,
                            expression: "item.domain"
                          }
                        ],
                        staticClass: "ml-1"
                      },
                      [_vm._v(" - " + _vm._s(item.domain) + " ")]
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.serviceID,
              callback: function callback($$v) {
                _vm.serviceID = $$v
              },
              expression: "serviceID"
            }
          })
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          !_vm.validated
            ? _c(
                "gg-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    tile: "",
                    color: "primary",
                    disabled: _vm.loading,
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.validate
                  }
                },
                [_vm._v(" Validate ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }